// panel-wrapper.component.ts
import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldWrapper, FormlyFormOptions } from '@ngx-formly/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Config } from 'src/app/config';
import { CommentService } from 'src/app/services/comment.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'formly-question-wrapper',
  templateUrl: 'widgets-question-wrapper.component.html',
  styleUrls: ['./widgets-question-wrapper.component.scss']
})
export class WidgetsQuestionWrapperComponent extends FieldWrapper  {
  @ViewChild('commentDialog') templateRefConfirmation?: ElementRef;
  modalRefConf: BsModalRef = new BsModalRef();
  commentModel = {};
  commentForm: FormGroup = new FormGroup({});
  isCommentReq: boolean = false;
  currentQusId: string = '';
  questionClickData = new Map();
  commentFields: FormlyFieldConfig[] = [{
    key: 'Comment',
    type: 'textarea',
    validators: { validation: ['trimValidation'] },
    className: 'dialog-comment-textarea',
    id: 'CommentBox',
    props: {
      label: 'comment',
      rows: 5,
    }, 
    expressions: {
      'props.required': () => {
        return this.isCommentReq;
      }
    }
  }
  ];
  commentOptions: FormlyFormOptions = {};
  isCommentFieldFilled = false;
  isQuestionCommentEnabled: boolean = false;
  isQuestionCommentRequired: boolean = false;

  constructor(
    public modalService: BsModalService,
    private commentService: CommentService
  ) {
    super();
    const getFeature = Config.FEATURES.get('isQuestionCommentEnabled');
    this.isQuestionCommentEnabled = (getFeature && (getFeature === true)) ? true : false;
  }

  ngOnInit(){
    this.commentService.castValue.subscribe((questionCast) => {
      this.isCommentReq = questionCast.isCommentReq;
      this.currentQusId = questionCast.questionId;
      this.isCommentRequ();
    });

    this.isQuestionCommentRequired = this.isCommentRequired();
  }

  /**
    * It march clicked question with to.question, if same store it in questionClickData
    * If id not match then remove from questionClickData
  * */ 
  isCommentRequ() {
    if (this.currentQusId == this.to.id && this.isCommentReq) {
      this.questionClickData.set(this.currentQusId, true);
    } else {
      this.questionClickData.delete(this.currentQusId);
    }
  }

  isCommentRequired() {
    if (this.field?.props?.attributes && this.field.props.attributes) {
      if (this.field.props.attributes.isCommentRequired === 'true') {
        return true;
      }
    }
    return false;
  }

  confirm() {
    this.modalRefConf.hide();
    this.isCommentFieldFilled = true;
  }

  onClick() {
    if (!this.commentModel['Comment']){
      this.isCommentFieldFilled = false;
    }
    if (!this.commentForm.valid) {
      return false;
    }

    // Get comment key
    let newCommentKey = this.field.key + 'Comment';
    const question = this.field;
    const questionTitle = question.props?.label;
    let firstPrimitiveKey: any = undefined;
    try {
      if (question.fieldGroup && question.fieldGroup[0] && 
        question.fieldGroup[0].fieldGroup && question.fieldGroup[0].fieldGroup[1]) {
        const questionGroup: FormlyFieldConfig = question.fieldGroup[0];
        const firstPrimitive: FormlyFieldConfig = questionGroup.fieldGroup![1];
        firstPrimitiveKey = firstPrimitive.key;
        newCommentKey = (firstPrimitive?.props?.commentKey) ? firstPrimitive?.props?.commentKey : newCommentKey;
      }
    } catch(error) {
      console.log("QuestionWrapper Error "+error);
    }

    /* eslint-enable */
    // if (question.fieldGroup && question.fieldGroup[0] &&
    //   question.fieldGroup[question.fieldGroup.length - 1].id !== 'CommentBox') {  
    //   const temp: FormlyFieldConfig = {
    //     // key: question.key + 'Comment',
    //     key: newCommentKey,
    //     type: 'textarea',
    //     validators: { validation: ['trimValidation'] },
    //     className: 'dialog-comment-textarea',
    //     id: 'CommentBox',
    //     // eslint-disable-next-line @typescript-eslint/dot-notation
    //     defaultValue: this.commentModel['Comment'],        
    //     // hideExpression: true,
    //     props: {
    //       label: 'comment',
    //       required: true,
    //       // required: (this.isQuestionCommentRequired && this.isQuestionCommentRequired === true) ? this.isQuestionCommentRequired : undefined,
    //     },
    //     expressions: { hide : "true" }
    //   };
    //   // TODO: Check: no duplicates
    //   question.fieldGroup?.push(temp);
    //   (this.options as any)._buildForm();
    // } else {
    //   // eslint-disable-next-line @typescript-eslint/dot-notation
    //   this.model[newCommentKey] = this.commentModel['Comment'];
    // }

    // OPTION 1
    // this.model[newCommentKey] = this.commentModel['Comment'];
    // this.model[newCommentKey+Config.CONSTANTS.commentKeyTitle] = questionTitle;
    // this.model[newCommentKey+Config.CONSTANTS.commentKeyTagName] = firstPrimitiveKey;

    // OPTION 3: Array of comments
    if (!this.model.comment) {
      this.model.comment = [];
    }
    this.model.comment.push( { index: newCommentKey, title: questionTitle, key: firstPrimitiveKey, comment: this.commentModel['Comment']} );

    this.confirm();
  }

  openCommentConfirmation(field) {
    this.modalRefConf = this.modalService.show(this.templateRefConfirmation);
  }
}
